<template>
    <div>
        <section-hero
            first
            section-name="offices_nice_hero"
            @scroll="$router.push({ hash: '#contact-nice' })"
        />
        <the-section :id="`contact-all-offices`">
            <contact-all-offices />
        </the-section>
        <section-gallery name="nice" />
        <section-hero section-name="offices_cairo_hero" />
        <section-gallery name="cairo" />
        <section-contact mode="footer" />
    </div>
</template>

<script>
import SectionGallery from "@/components/SectionGallery";
import SectionContact from "@/components/SectionContact";
import SectionHero from "@/components/SectionHero";
import ContactAllOffices from "@/components/ContactAllOffices";
import TheSection from "@/components/TheSection";

export default {
    components: {
        SectionGallery,
        SectionHero,
        SectionContact,
        ContactAllOffices,
        TheSection,
    },
};
</script>
